module.exports = __webpack_public_path__ + "img/bg.4d8f4149.gif";